import { render, staticRenderFns } from "./GFEBSAssignedReferenceNumber.vue?vue&type=template&id=a9b2b0c4&"
import script from "./GFEBSAssignedReferenceNumber.vue?vue&type=script&lang=js&"
export * from "./GFEBSAssignedReferenceNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports